<template>
    <div id="modal_info_component" class="modal-component" v-if="displayModal">
        <div class="modal-area">
            <div class="modal-overlay">
                <div class="modal-overlay-inside">
                    <div class="modal-outer">
                        <div class="modal-close" @click="hideModal()"></div>
                        <div class="modal-inner text-left">
                            <img class="logo" src="../../../../../assets/img/ftn_popup.png" alt="FuturoNetwork">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['popup'],
        data () {
            return {
                displayModal: !localStorage.getItem('infoModal'),
            }
        },
        methods: {
            hideModal () {
                localStorage.setItem('infoModal', '1');
                this.displayModal = false;
                this.popup.hide();
            }
        }
    }
</script>

<style lang="scss" scoped>
    #modal_info_component {
        .modal-overlay {
            background: rgba(0,0,0,0.4);
            .modal-outer {
                padding: 0;
                max-width: 720px;
                .modal-inner {
                    p {
                        margin-top: 0;
                        margin-bottom: 1rem;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/partials/section/modals/InfoModal.vue